package com.essntl.core.quickbooks.data

import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksItemDto(
    val Item: QuickbooksItem,
    val time: String,
)

@Serializable
data class QuickbooksItem(
    val Id: String,
)

@Serializable
data class QuickbooksItemMetaData(
    val CreateTime: String? = null,
    val LastUpdatedTime: String? = null,
)